import React from 'react';
import { Card, CardBody } from '@heroui/react';
import { ReadOnlyRating } from '~/components/molecules/ReadOnlyRating';
import { ROUTES } from '~/constants/routes.contants';
import { FoodResponseDto } from '@bitecritic-api/src/foods/dto/food.response.dto';
import { titleAndIdToSlug } from '~/utils/slug-utils';
import { FollowButton } from '../FollowButton';
import { BaseLink } from '~/components/atoms/Link';

interface FoodCardSmallProps {
  food: FoodResponseDto
  className?: string
  showFollowButton?: boolean;
  showRating?: boolean;
}

export const FoodCardSmall: React.FC<FoodCardSmallProps> = ({ food, className, showFollowButton = true, showRating = true }) => {


  const height = showFollowButton ? '72px' : '48px';

  return (
    <Card className={`w-full bg-warning-50 border border-warning-300 ${className || ''}`}>
      <CardBody>
        <div className="flex flex-col gap-2"
          style={{
            height: height
          }}
        >
          <BaseLink
            href={`${ROUTES.FOODS}/${titleAndIdToSlug(food.name, food.id.toString())}`}
            className="flex justify-between items-start"
          >
            <div>
              <h3 className="font-semibold text-base text-foreground group-hover:text-warning-700 transition-colors truncate">{food.name}</h3>
              {food.category && (
                <p className="text-small text-secondary-800">{food.category.name}</p>
              )}
            </div>
            {showRating && (
              <div className="flex items-center gap-2 h-100">
                <p className="text-small text-foreground-500">({food.reviewCount})</p>
                <ReadOnlyRating rating={food.reviewOverallRating || 0} size="sm" />
              </div>
            )}
          </BaseLink>
        </div>
        {showFollowButton && (
          <div className='absolute bottom-4 right-4 h-100'>
            <FollowButton
              foodId={food.id}
              size='sm'
            />
          </div>
        )}
      </CardBody>
    </Card>
  );
}; 